(function() {
  try {
    var log = debug('mz-ble-device');
  } catch(err) {
    var log = function() {};
  }

  log('loaded');

  // -----------------------------------------------------------------
  // BLE
  // -----------------------------------------------------------------
  var serviceUuid =        "0000ffe0-0000-1000-8000-00805f9b34fb";
  var characteristicUuid = "0000ffe1-0000-1000-8000-00805f9b34fb";
  var bleCharacteristic = null;
  var bleDevice = null;

  var startCode = 'S';
  var stopCode = 'E';
  var littleEndian = true;

  var dataLength = 5;

  var vibExtIdx = 0;
  var tempIdx = 1;  
  var vibIdx = 2;

  var bytesPerElement = Float32Array.BYTES_PER_ELEMENT;
  var byteLength = dataLength * bytesPerElement;

  // -----------------------------------------------------------------

  var ts0;

  var mzBleDevice = window.mzBleDevice = {
    connected: false,
    isConnecting: false,
    events: {},
    eventLabels: [
      'connected',
      'disconnected',
      'started',
      'stopped',
      'data',
    ]
  };

  mzBleDevice.eventLabels.forEach(function(label) {
    mzBleDevice.events[label] = [];
  });

  mzBleDevice.options = {
    warn: 1.2,
    alarm: 1.5,
  };

  mzBleDevice.connect = function(options) {
    log('mzBleDevice#connect')

    options = options || {};
    Object.keys(options).forEach(function(key) {
      mzBleDevice.options[key] = options[key];
    });

    if (!navigator.bluetooth) {
      return alert('your browser does not support bluetooth!');
    }

    _connect(mzBleDevice.options);
  };

  mzBleDevice.disconnect = function() {
    log('mzBleDevice#disconnect')

    _disconnect();
  };

  mzBleDevice.start = function() {
    log('mzBleDevice#start')

    if (!mzBleDevice.connected) {
      log('mzBleDevice is not connected');
      return;
    }

    _start();
  };

  mzBleDevice.stop = function() {
    log('mzBleDevice#stop')

    if (!mzBleDevice.connected) {
      log('mzBleDevice is not connected');
      return Promise.reject(new Error('device is not connected'));
    }

    return _stop();
  };

  mzBleDevice.on = function(event, eventCallback) {
    if (mzBleDevice.events[event] !== undefined) {
      mzBleDevice.events[event].push(eventCallback);
      return log('event registered:', event);
    }

    log('unkown event: ' + event);
  };

  function _connect(options) {
    log('_connect');

    navigator.bluetooth.requestDevice({filters: [{services: [serviceUuid]}]})
      .then(function(_device) {
        log('connecting to GATT server...');
        bleDevice = _device;
        mzBleDevice.isConnecting = true;
        bleDevice.addEventListener('gattserverdisconnected', _disconnectCallback)
        return bleDevice.gatt.connect();
      })
      .then(function(server) {
        log('getting service...');
        // return server.getPrimaryService(serviceUuid);
        return server.getPrimaryServices();
      })
      .then(function(services) {
        // log('listing services...');
        const service = services.filter(_service => {
          log('> Service: ' + _service.uuid);
          return _service.uuid === serviceUuid;
        })[0];

        if (!service) {
          throw 'service not found';
        }

        log('getting characteristic...');
        return service.getCharacteristic(characteristicUuid);
      })
      .then(function(characteristic) {
        bleCharacteristic = characteristic;
        return bleCharacteristic.startNotifications().then(function(_) {
          log('notifications started...');
          bleCharacteristic.addEventListener('characteristicvaluechanged',
            _notificationCallback);

          _connectCallback();
        });
      })
      .catch(function(err) {
        mzBleDevice.isConnecting = false;
        log('arrrgh! ' + err);
      });
  }

  function _notificationCallback(event) {
    log('_notificationCallback');

    var val = event.target.value;

    var rawData = [];
    var err = null;

    log('bytes received: ' + val.byteLength)

    for (var j = 0; j < dataLength; j++) {
      rawData.push(val.getFloat32(j*bytesPerElement, littleEndian));
    }

    _parseData(rawData);
  }

  function _parseData(rawData) {
    var ts = Date.now();
    if (ts0 === undefined) {
      ts0 = ts;
    }

    var t = (ts - ts0) / 1000;

    var vib = rawData[vibIdx];
    var vibExt = rawData[vibExtIdx];
    var temp = rawData[tempIdx];

    var warn = false;
    var alarm = false;

    if (vib > mzBleDevice.options.alarm || vibExt > mzBleDevice.options.alarm) {
      alarm = true;
    } else if (vib > mzBleDevice.options.warn || vibExt > mzBleDevice.options.warn) {
      warn = true;
    }

    var data = {
      ts: ts,
      vib: vib,
      vibExt: vibExt,
      temp: temp,
      warn: warn,
      alarm: alarm,
    };

    if (mzBleDevice.connected) {
      mzBleDevice.events.data.forEach(function(cb) {
        cb(data);
      });      
    }
  }

  function _connectCallback() {
    log('_connectCallback');

    mzBleDevice.connected = true;
    mzBleDevice.isConnecting = false;
    mzBleDevice.events.connected.forEach(function(cb) {
      cb(mzBleDevice.running);
    });
}

  function _disconnectCallback() {
    log('_disconnectCallback')

    mzBleDevice.connected = false;
    mzBleDevice.isConnecting = false;
    mzBleDevice.events.disconnected.forEach(function(cb) {
      cb();
    });
  }


  function _disconnect() {
    log('_disconnect');

    if (bleDevice.gatt.connected) {
      return bleDevice.gatt.disconnect();
    }

    log('bleDevice is already disconnected');      
  }

  function _start() {
    log('_start');

    if (!bleCharacteristic) {
      log('no characteristic... canceled');
      return;
    }    

    bleCharacteristic.writeValue(Uint8Array.of(startCode.charCodeAt(0)))
    .then(function(_) {
      log('sent startCode: ' + startCode);
    })
    .catch(function(err) {
      log('[ERROR] could not send startCode: ' + err);
    });
  }

  function _stop() {
    log('_stop');

    if (!bleCharacteristic) {
      log('no characteristic... canceled');
      return;
    }    

    return bleCharacteristic.writeValue(Uint8Array.of(stopCode.charCodeAt(0)))
    .then(function(_) {
      log('sent stopCode: ' + stopCode);
    })
    .catch(function(err) {
      log('[ERROR] could not send stopCode: ' + err);
    });
  }
})();



// WEBPACK FOOTER //
// ./src/lib/ble.js